import React, {useState} from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect
} from "react-router-dom";
import Main from './pages/Main';
import Todo from './pages/Todo';
import ErrorPage404 from './pages/ErrorPage404';
import MenuAppBar from './components/MenuAppBar';

function App() {
  return (
    <div>
      <Router>
        
        <Link className="myLink" to='/'>Notes </Link>
        <Link className="myLink" to='/todo'>Todo List</Link>
        <Link className="myLink" to='/404'>Not Found</Link>
        <Switch>
          <Route exact path="/" component={Main} />
          <Route exact path="/notes-app/" component={Main}></Route>
          <Route exact path="/todo" component={Todo} />
          <Route exact path="/404" component={ErrorPage404} />
          <Redirect to='/404' />
        </Switch> 
      </Router>
    </div>
    
  );
}

export default App;
